import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { createUseFoundationHook } from '@cld/design-system-foundations';
import { blenderCss, OpaqueColorName } from '@cld/blender';
import { globalTheme } from '@cld/component-theme';
import { iconNextSizeVariant, ThemeProps } from './theme';
import { IconProps } from './types';

export interface GenericIconProps extends IconProps {
  path: string;
}

const palette = globalTheme.palette;

const getColor = (colorName: string | OpaqueColorName) => palette[(colorName as unknown) as keyof typeof palette] ?? colorName;

const StyledSvg = styled.svg<ThemeProps & Pick<GenericIconProps, 'color'>>`
  width: ${iconNextSizeVariant((variant) => variant.width)};
  height: ${iconNextSizeVariant((variant) => variant.width)};
  fill: ${(props) => (props.color === undefined ? css`var(${blenderCss.variables.foregroundColor}, currentColor)` : getColor(props.color))};
`;

const { useFoundation } = createUseFoundationHook<Pick<IconProps, 'size'>>(
  ({ size }) => ({ size: size === 'xxs' ? 'xs' : size }),
  (props) => props,
  { size: 'md' }
);

export const GenericIcon: FC<GenericIconProps> = ({ size, color, path, ...rest }) => {
  const foundation = useFoundation({ size });

  return (
    <StyledSvg {...foundation.componentProps} color={color} viewBox="0 0 24 24" preserveAspectRatio="xMidYMid" {...rest}>
      <path d={path} />
    </StyledSvg>
  );
};
